/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapPrintOptions } from './print-options.model';
import { Action, Selector, State } from '@ngxs/store';
import { SetPrintOptions } from './print-options.actions';
import { of } from 'rxjs';
import { DashGisUtil } from '../../../../shared/dash-gis-util';
import { Injectable } from '@angular/core';

@State<MapPrintOptions>({
    name: 'printOptions',
    defaults: {
        paperSize: null,
        showLegend: true,
        showTitle: true,
        showNorth: true,
        titleText: '',
        highQuality: true,
    }
})
@Injectable()
export class PrintOptionsState {

    @Selector()
    static options(state: MapPrintOptions) {
        return state;
    }

    @Selector()
    static paperSize(state: MapPrintOptions) {
        return state.paperSize;
    }

    @Selector()
    static titleText(state: MapPrintOptions) {
        return state.titleText;
    }

    @Selector()
    static showTitle(state: MapPrintOptions) {
        return state.showTitle;
    }

    @Selector()
    static showLegend(state: MapPrintOptions) {
        return state.showLegend;
    }

    @Selector()
    static showNorth(state: MapPrintOptions) {
        return state.showNorth;
    }

    @Selector()
    static highQuality(state: MapPrintOptions) {
        return state.highQuality;
    }

    @Action(SetPrintOptions)
    setSettings({getState, setState}, action: SetPrintOptions) {
        const newState = DashGisUtil.clone(getState());
        Object.getOwnPropertyNames(action.payload).forEach((prop) => {
            newState[prop] = action.payload[prop];
        });
        setState(newState);
        return of(action.payload);
    }
}
